import { ProcessorType } from "./processor.types";

export interface Statistic {
    id: string;
    color: string;
    name: string;
    type?: string;
    quantitativePercent: number;
    quantitativeValue: number;
    qualitativePercent: number;
    qualitativeValue: number;
}

export enum StatusType {
    APPROVED = 'APPROVED',
    CHARGEBACK = 'CHARGEBACK',
    REFUNDED = 'REFUNDED',
    DECLINED = 'DECLINED',
    PENDING = 'PENDING',
    ERROR = 'ERROR',
    RDR = 'RDR'
}

export enum IntermediateStatusType {
    DONE = 'DONE',
    PENDING_APPROVE = 'PENDING_APPROVE',
    PENDING_REFUND = 'PENDING_REFUND',
    PENDING_CHARGEBACK = 'PENDING_CHARGEBACK',
}

export enum CardBrandType {
    VISA = 'Visa',
    MASTERCARD = 'MasterCard',
    AMERICA_EXPRESS = 'American Express'
}


export interface StatisticLineChartData {
    label: string;
    values: { date: string; transactionNo: number }[];
    colors: string[];
}


export interface LegendItem {
    label: string;
    selected: boolean;
    colors: string[];
}




